import React from "react";
import { Link } from "react-router-dom";

function Sidebar() {
  return (
    <div className="w-64 bg-gray-800 min-h-screen text-white">
      <div className="p-4">
        <nav className="space-y-2">
          <Link
            to="/dashboard"
            className="block py-2.5 px-4 rounded hover:bg-gray-700"
          >
            Dashboard
          </Link>
          <Link
            to="/customers"
            className="block py-2.5 px-4 rounded hover:bg-gray-700"
          >
            Customers
          </Link>
          <Link
            to="/orders"
            className="block py-2.5 px-4 rounded hover:bg-gray-700"
          >
            Orders
          </Link>
          <Link
            to="/invoices"
            className="block py-2.5 px-4 rounded hover:bg-gray-700"
          >
            Notas Fiscais
          </Link>
          <Link
            to="/CondicaoComercial"
            className="block py-2.5 px-4 rounded hover:bg-gray-700"
          >
            CondicaoComercial
          </Link>
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;
